export const getSixthFlowId = state => state.sixthFlows.sixthFlow.id;
export const getSixthFlowData = state => state.sixthFlows.sixthFlow;
export const sixthFlowIsFetching = state => state.sixthFlows.loading;